import { ClientOutputDTO } from './types';

export const ClientMapper = {
  toDTO: (data: Partial<ClientOutputDTO>): Partial<ClientOutputDTO> => {
    return {
      ...data,
    };
  },

  toView: (data: ClientOutputDTO): ClientOutputDTO => {
    return data; // Por enquanto retorna o mesmo objeto, podemos expandir se necessário
  },
};
